<template>
  <div class="flex align-center">
    <div class="flex align-center margin-right-sm">
      <span>社区：</span>
      <el-select v-model="project" placeholder="请选择社区" class="flex-sub" @change="fristChange" >
        <el-option
            v-for="item in projectList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
        </el-option>
      </el-select>
    </div>
    <div class="flex align-center margin-right-sm">
      <span>小区：</span>
      <el-select v-model="community" placeholder="请选择小区" class="flex-sub" >
        <el-option
            v-for="item in communityList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
        </el-option>
      </el-select>
    </div>
    <el-button type="primary" @click="SearchInfo">搜索</el-button>
  </div>
</template>

<script>
import {getXiangMuList, getXiaoQuList} from "@/api/common";
import {filesCNOher} from "@/utils/utils";

export default {
  name: "two-level",
  data() {
    return {
      projectList: [{id: 0, name: '全部社区'}],
      project: 0,
      communityList: [{id: 0, name: '全部小区'}],
      community: 0,
    }
  },
  created() {
    this.SearchInfo()
    this.getXiangMuList()
  },
  components: {},
  methods: {
    /*
    * 获取社区列表
    * */
    async getXiangMuList() {
      let _data = await getXiangMuList()
      this.projectList = [...this.projectList, ..._data.data]
    },

    /*
   * 获取小区列表
   * */
    async getXiaoQuList(id) {
      let _data = await getXiaoQuList(id)
      this.communityList = [...this.communityList, ..._data.data]
    },
    fristChange(e) {
      this.communityList = [{id: 0, name: '全部小区'}]
      this.community = 0
      if(e) this.getXiaoQuList(e)
    },
    /*
    * 提交搜索数据
    * */
    SearchInfo() {
      this.$emit('SearchInfo', {
        project:this.project,
        community:this.community,
        projectName:filesCNOher(this.project,this.projectList),
        communityName:filesCNOher(this.community,this.communityList),
      })
    }
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">

</style>
